import { observable } from "mobx";
import AccountingDocumentsInventoryDeletionActionRejectionReason from "./accountingDocumentsInventoryDeletionActionRejectionReason";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class AccountingDocumentsInventoryDeletionActionResponse {
  @observable
  isAllowed!: boolean;

  @observable
  rejectionReason?: AccountingDocumentsInventoryDeletionActionRejectionReason;
}
